/* OVD drag-to-scroll for horizontal carousels (desktop mice).
   Mac/iOS get horizontal swipe for free; a Windows mouse has no gesture for
   overflow-x, so the scrollers were unreachable there. Click-and-drag any
   horizontal strip; a <6px movement still counts as a click, so product
   cards keep opening normally. Touch input is untouched — native scrolling
   already handles it. */
(function () {
  if (window.__ovdDragScroll) return;
  window.__ovdDragScroll = true;

  var SEL = '.product-carousel-scroll, .media-banner-grid.one-line';
  var THRESHOLD = 6; // px before a press becomes a drag instead of a click

  var strip = null, startX = 0, startY = 0, startLeft = 0, dragging = false, moved = false;
  var samples = [], glideId = 0;

  /* momentum: a flick keeps gliding after release, like a trackpad swipe */
  function glide(s, v) {
    cancelAnimationFrame(glideId);
    var last = performance.now();
    (function step(now) {
      var dt = Math.min(now - last, 40); last = now;
      s.scrollLeft += v * dt;
      v *= Math.pow(0.994, dt);
      var atEnd = s.scrollLeft <= 0 || s.scrollLeft >= s.scrollWidth - s.clientWidth - 1;
      if (Math.abs(v) > 0.02 && !atEnd) glideId = requestAnimationFrame(step);
      else { s.style.scrollSnapType = ''; s.style.scrollBehavior = ''; }
    })(last);
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var s = e.target.closest && e.target.closest(SEL);
    if (!s || s.scrollWidth <= s.clientWidth + 2) return;
    cancelAnimationFrame(glideId);
    s.style.scrollSnapType = '';      // an interrupted glide must not leave
    s.style.scrollBehavior = '';      // snap disabled forever
    strip = s; startX = e.clientX; startY = e.clientY;
    startLeft = s.scrollLeft; dragging = false; moved = false;
    samples = [];
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!strip) return;
    var dx = e.clientX - startX, dy = e.clientY - startY;
    if (!dragging) {
      if (Math.abs(dx) < THRESHOLD || Math.abs(dx) < Math.abs(dy)) return; // vertical intent: leave it to the page
      dragging = true; moved = true;
      strip.style.scrollSnapType = 'none';     // snap fights the hand mid-drag
      strip.style.scrollBehavior = 'auto';
      try { strip.setPointerCapture(e.pointerId); } catch (err) {}
    }
    strip.scrollLeft = startLeft - dx;
    samples.push({ x: e.clientX, t: performance.now() });
    if (samples.length > 6) samples.shift();
    e.preventDefault();
  }, true);

  function end(e) {
    if (!strip) return;
    var s = strip; strip = null;
    if (!dragging) return;
    dragging = false;
    try { s.releasePointerCapture(e.pointerId); } catch (err) {}
    /* momentum from the last ~100ms of movement */
    var now = performance.now();
    var recent = samples.filter(function (p) { return now - p.t < 120; });
    if (recent.length >= 2) {
      var a = recent[0], b = recent[recent.length - 1];
      var v = (a.x - b.x) / Math.max(now - a.t, 16);   // px per ms, drag direction
      if (Math.abs(v) > 0.15) { glide(s, v); return; } // snap stays off while gliding
    }
    s.style.scrollSnapType = '';
    s.style.scrollBehavior = '';
  }
  document.addEventListener('pointerup', end, true);
  document.addEventListener('pointercancel', end, true);

  /* a press that became a drag must not fire the card's link */
  document.addEventListener('click', function (e) {
    if (moved) { moved = false; e.preventDefault(); e.stopPropagation(); }
  }, true);
})();

/* Carousel arrow buttons: bound per button (survives section re-renders),
   strip re-queried at click time, movement animated manually so neither
   scroll-snap nor inline scroll-behavior styles can swallow it. */
(function () {
  if (window.__ovdArrows) return;
  window.__ovdArrows = true;

  function animateTo(s, target) {
    target = Math.max(0, Math.min(target, s.scrollWidth - s.clientWidth));
    var from = s.scrollLeft, dist = target - from, t0 = performance.now(), D = 320;
    if (!dist) return;
    var snap = s.style.scrollSnapType;
    s.style.scrollSnapType = 'none';
    var done = false;
    (function step(now) {
      var p = Math.min((now - t0) / D, 1);
      s.scrollLeft = from + dist * (1 - Math.pow(1 - p, 3)); // ease-out cubic
      if (p < 1) requestAnimationFrame(step);
      else { done = true; s.style.scrollSnapType = snap || ''; }
    })(t0);
    /* rAF starves in hidden/throttled tabs — land the scroll regardless */
    setTimeout(function () {
      if (!done) { s.scrollLeft = target; s.style.scrollSnapType = snap || ''; }
    }, D + 200);
  }

  function onArrow(e) {
    e.preventDefault(); e.stopPropagation();
    var c = this.closest('.product-carousel-container');
    var s = c && c.querySelector('.product-carousel-scroll');
    if (!s) return;
    var dir = parseInt(this.getAttribute('data-ovd-arrow'), 10) || 1;
    animateTo(s, s.scrollLeft + dir * Math.round(s.clientWidth * 0.8));
  }

  function syncOne(s) {
    var c = s.closest('.product-carousel-container');
    if (!c) return;
    var prev = c.querySelector('.pc-arrow--prev'), next = c.querySelector('.pc-arrow--next');
    var max = s.scrollWidth - s.clientWidth;
    if (prev) { if (s.scrollLeft <= 2) prev.setAttribute('data-ovd-hidden', ''); else prev.removeAttribute('data-ovd-hidden'); }
    if (next) { if (s.scrollLeft >= max - 2 || max <= 2) next.setAttribute('data-ovd-hidden', ''); else next.removeAttribute('data-ovd-hidden'); }
  }

  function tick() {
    document.querySelectorAll('[data-ovd-arrow]:not([data-ovd-bound])').forEach(function (b) {
      b.setAttribute('data-ovd-bound', '');
      b.addEventListener('click', onArrow);
    });
    document.querySelectorAll('.product-carousel-scroll').forEach(syncOne);
  }

  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('product-carousel-scroll')) syncOne(e.target);
  }, true);
  window.addEventListener('resize', tick, { passive: true });
  ['barba:after', 'barba:enter'].forEach(function (ev) { window.addEventListener(ev, function () { setTimeout(tick, 300); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);
  else tick();
  setInterval(tick, 1500);
})();
